import ImportFinish from './src/import-finish.vue'
import { withInstall } from '../../utils/vue/install'

export default withInstall(ImportFinish)